import { render, staticRenderFns } from "./LocaleTableItem.vue?vue&type=template&id=43100bf1&scoped=true"
import script from "./LocaleTableItem.vue?vue&type=script&lang=js"
export * from "./LocaleTableItem.vue?vue&type=script&lang=js"
import style0 from "./LocaleTableItem.vue?vue&type=style&index=0&id=43100bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43100bf1",
  null
  
)

export default component.exports